const makeRequestId = () => (
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`
);

export const createBoardRequestId = () => makeRequestId();

export const recordBoardRequestTelemetry = ({ requestId = "", httpStatus = 0, outcome = "", route = "" } = {}) => {
  if (typeof window === "undefined") {
    return;
  }

  window.__WW_LAST_BOARD_REQUEST = {
    requestId: String(requestId || "").slice(0, 64),
    httpStatus: Math.max(0, Math.min(599, Number(httpStatus) || 0)),
    requestOutcome: String(outcome || "").slice(0, 20),
    requestRoute: String(route || "").slice(0, 100),
    recordedAt: Date.now(),
  };
};

export const getLastBoardRequestTelemetry = () => {
  if (typeof window === "undefined" || !window.__WW_LAST_BOARD_REQUEST) {
    return {};
  }

  return { ...window.__WW_LAST_BOARD_REQUEST };
};
